import { render, staticRenderFns } from "./ProjectsSingleIntro.vue?vue&type=template&id=213294d6&"
import script from "./ProjectsSingleIntro.vue?vue&type=script&lang=js&"
export * from "./ProjectsSingleIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports